import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "empty-table-msg" }



interface Props {
  colspan?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyMessage',
  props: {
    colspan: { default: 1 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tbody", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        colspan: props.colspan
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("component.table.noItems")), 1)
      ], 8, _hoisted_1)
    ])
  ]))
}
}

})